/**
 * @generated SignedSource<<e42ebbc3c9c5b9c16390cb4ae51e062b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JswBoardsRefactored$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly boards: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: "JiraBoard";
            readonly boardId: AGG$Long | null | undefined;
            readonly defaultNavigationItem: {
              readonly url?: string | null | undefined;
            } | null | undefined;
            readonly favouriteValue: {
              readonly isFavourite: boolean | null | undefined;
            } | null | undefined;
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly isFavourite: boolean | null | undefined;
      readonly mostRecentlyViewedBoard: {
        readonly boardId?: AGG$Long | null | undefined;
      } | null | undefined;
      readonly projectId: string;
      readonly projectKey: string;
      readonly projectType: JiraProjectType | null | undefined;
      readonly softwareBoardCount: AGG$Long;
      readonly " $fragmentSpreads": FragmentRefs<"BoardActions">;
    };
  };
  readonly settings_navigationCustomisation: {
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null | undefined;
        readonly visible: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "JswBoardsRefactored";
};
export type JswBoardsRefactored$key = {
  readonly " $data"?: JswBoardsRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"JswBoardsRefactored">;
};

import JswBoardsRefactoredRefetchQuery_graphql from './JswBoardsRefactoredRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v2 = {
  "kind": "ScalarField",
  "name": "boardId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityAri"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "noOfBoardsToFetch"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ownerAri"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": JswBoardsRefactoredRefetchQuery_graphql
    }
  },
  "name": "JswBoardsRefactored",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                },
                {
                  "kind": "Variable",
                  "name": "key",
                  "variableName": "projectKey"
                }
              ],
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "BoardActions"
                },
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.projectId"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": "projectKey",
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.projectKey"
                },
                {
                  "kind": "ScalarField",
                  "name": "projectType"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "first",
                      "variableName": "noOfBoardsToFetch"
                    }
                  ],
                  "concreteType": "JiraBoardConnection",
                  "kind": "LinkedField",
                  "name": "boards",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraBoardEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraBoard",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "RequiredField",
                              "field": {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              "action": "THROW",
                              "path": "jira.jiraProjectByKey.boards.edges.node.__typename"
                            },
                            (v0/*: any*/),
                            {
                              "kind": "ScalarField",
                              "name": "name"
                            },
                            (v2/*: any*/),
                            {
                              "kind": "LinkedField",
                              "name": "defaultNavigationItem",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "url"
                                    }
                                  ],
                                  "type": "JiraNavigationItem",
                                  "abstractKey": "__isJiraNavigationItem"
                                }
                              ]
                            },
                            {
                              "concreteType": "JiraFavouriteValue",
                              "kind": "LinkedField",
                              "name": "favouriteValue",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "name": "mostRecentlyViewedBoard",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v2/*: any*/)
                      ],
                      "type": "JiraBoard"
                    }
                  ]
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "softwareBoardCount"
                  },
                  "action": "THROW",
                  "path": "jira.jiraProjectByKey.softwareBoardCount"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.jiraProjectByKey"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "entityAri"
        },
        {
          "kind": "Variable",
          "name": "ownerAri",
          "variableName": "ownerAri"
        }
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItemConnection",
          "kind": "LinkedField",
          "name": "sidebar",
          "plural": false,
          "selections": [
            {
              "concreteType": "SettingsMenuItem",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "menuId"
                },
                {
                  "kind": "ScalarField",
                  "name": "visible"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "ec07e020c7e43fbb502416050eaf237f";

export default node;
